export function getDateDifferenceInDays(createdAt: string | Date): number {
  if (!createdAt) return 0;
  
  const createdDate = new Date(createdAt);
  const currentDate = new Date();
  
  // Calculate the difference in milliseconds
  const diffTime = Math.abs(currentDate.getTime() - createdDate.getTime());
  // Convert to days
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  return diffDays;
}

export function getDelayStatusColor(createdAt: string | Date): string {
  const diffDays = getDateDifferenceInDays(createdAt);
  
  if (diffDays <= 3) {
    return '#4CAF50'; // Green for less than or equal to 3 days
  } else if (diffDays <= 7) {
    return '#FF9800'; // Orange for less than or equal to 7 days
  } else {
    return '#F44336'; // Red for more than 7 days
  }
}

export function getDelayStatusText(createdAt: string | Date): string {
  const diffDays = getDateDifferenceInDays(createdAt);
  
  if (diffDays <= 3) {
    return `${diffDays} days (Normal)`;
  } else if (diffDays <= 7) {
    return `${diffDays} days (Delayed)`;
  } else {
    return `${diffDays} days (Critical)`;
  }
} 